import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import UpgradeArrow from './icon-upgrade-arrow.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <UpgradeArrow {...validProps} />;
}
SvgComponent.iconName = 'upgrade-arrow';

/**
 * @deprecated This is a legacy icon
 */
export const UpgradeArrowIcon = svgIconWrapper(SvgComponent);
